import axios from "axios";
import {GROLOG_URL} from "../../../constant/apiConstant";

const api = GROLOG_URL;

export const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
  const url = api + endpoint;
  const method = "PUT";
  const headers = {'Authorization': tkn};
  const request = {url, method, headers, data};
  return axios(request);
};
export const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
  const url = api + endpoint;
  const method = "POST";
  const headers = {'Authorization': tkn};
  const request = {url, method, headers, data};
  return axios(request);
};

export const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
  const url = api + endpoint;
  const method = "GET";
  const headers = {'Authorization': tkn};
  const request = {url, method, headers, params};
  return axios(request);
};